import sortBy from 'lodash/sortBy';

/**
 * The weights on one lift, for the Plates screen (#51): one entry per distinct weight, in the
 * order the set rows appear on the workout screen (by pos, missing pos last, the same rule
 * Exercise.js uses to list them). Rows at the same weight merge, keeping each row's sets and reps.
 *
 * Each entry: { weight, sets: [{ sets, reps }, ...] }. `weight` is the first matching row's value
 * as stored, so a lift with one weight opens Plates exactly as it did before this change.
 */
export default function weightRows(exerciseSets) {
  const rows = sortBy(Object.values(exerciseSets || {}), item => item.pos ?? 999);
  const groups = [];

  for (const row of rows) {
    const key = Number(row.weight) || 0;
    let group = groups.find(g => g.key === key);
    if (!group) {
      group = { key, weight: row.weight, sets: [] };
      groups.push(group);
    }
    group.sets.push({ sets: Number(row.sets) || 0, reps: Number(row.reps) || 0 });
  }

  return groups.map(({ weight, sets }) => ({ weight, sets }));
}

/** "3 sets of 5", or "3 sets of 5, 1 set of 3" when rows at one weight differ. */
export function setsLabel(sets) {
  return (sets || [])
    .map(({ sets: count, reps }) => `${count} ${count === 1 ? 'set' : 'sets'} of ${reps}`)
    .join(', ');
}
